import * as z from 'zod';

import { addressQuerySchema } from '@/_containers/inputs/address/shared';
import { fileQuerySchema } from '@/_schemas/file';
import { booleanQuerySchema } from '@/_schemas/generic';
import { paginatedResponseSchema } from '@/_schemas/generic/paginated-response';
import { phoneNumberQuerySchema } from '@/_schemas/phone-numbers';
import { statusQuerySchema } from '@/_schemas/status-input';

import { brandQueryLinkerSchema } from './brand-query-linker-schema';

export const brandQuerySchema = z.object({
  ...brandQueryLinkerSchema.shape,
  legal_name: z.string().nullable(),
  website: z.string().nullable(),
  email: z.string().nullable(),
  billing_email_address: z.string().nullable(),
  status: statusQuerySchema,
  code: z.string().nullable(),
  logo: z.array(fileQuerySchema).nullish(),
  logo_light: z.array(fileQuerySchema).nullish(),

  online_payment_url: z.url().nullable(),
  payable_to: z.string().nullable(),
  phone_numbers: z.array(phoneNumberQuerySchema).nullish(),
  addresses: z.array(addressQuerySchema).nullish(),
  invoice_logo: z.array(fileQuerySchema).nullish(),
  hide_online_payments: booleanQuerySchema(),
});

export type BrandQuerySchema = z.infer<typeof brandQuerySchema>;

export const brandAllQuerySchema = paginatedResponseSchema(brandQuerySchema);

export type BrandAllQuerySchema = z.infer<typeof brandAllQuerySchema>;
